import { useSubscription as apolloUseSubscription } from '@apollo/client'

type SubscriptionParameters<T> = Parameters<typeof apolloUseSubscription<T>>

export const useSubscription = <T>(...args: SubscriptionParameters<T>) => {
  const [query, options] = args

  // https://github.com/apollographql/apollo-client/issues/8677#issuecomment-1664502272
  return apolloUseSubscription(query, { fetchPolicy: 'no-cache', ...options })
}
